import { useState } from "react";

const certificates = [
  {
    label: "Registration Certificate",
    file: "/pdf/registration.pdf",
  },
  {
    label: "Second Certificate",
    file: "/pdf/AA3706260374632_RC30062026.pdf",
  },
];

const RegistrationCertificate = () => {
  const [loggedIn, setLoggedIn] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [activeIndex, setActiveIndex] = useState(0);

  const handleLogin = (e) => {
    e.preventDefault();

    if (email === "qnexservices@gmail.com" && password === "Qnexa@123") {
      setLoggedIn(true);
      setError("");
    } else {
      setError("Invalid email or password");
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      {!loggedIn ? (
        <div style={{ maxWidth: "350px", margin: "0 auto" }}>
          <h2 style={{ textAlign: "center" }}>Login to View PDF</h2>

          <form onSubmit={handleLogin}>
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{ width: "100%", marginBottom: "10px", padding: "8px" }}
            />

            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{ width: "100%", marginBottom: "10px", padding: "8px" }}
            />

            {error && <p style={{ color: "red" }}>{error}</p>}

            <button
              type="submit"
              style={{
                width: "100%",
                padding: "10px",
                background: "#007bff",
                color: "#fff",
                border: "none",
                cursor: "pointer",
              }}
            >
              Login
            </button>
          </form>
        </div>
      ) : (
        <div>
          <h2>Certificates</h2>

          {/* Tabs */}
          <div style={{ display: "flex", gap: "10px", marginBottom: "15px" }}>
            {certificates.map((cert, index) => (
              <button
                key={cert.file}
                onClick={() => setActiveIndex(index)}
                style={{
                  padding: "10px 16px",
                  background: activeIndex === index ? "#007bff" : "#f1f1f1",
                  color: activeIndex === index ? "#fff" : "#000",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                {cert.label}
              </button>
            ))}
          </div>

          {/* PDF viewer */}
          <iframe
            key={certificates[activeIndex].file}
            src={certificates[activeIndex].file}
            title={certificates[activeIndex].label}
            style={{
              width: "100%",
              height: "90vh",
              border: "1px solid #ccc",
            }}
          ></iframe>
        </div>
      )}
    </div>
  );
};

export default RegistrationCertificate;